// extracted by mini-css-extract-plugin
module.exports = {"home__hero":"Home_home__hero__Km9zR"};